import React, { useState } from "react";
import './RegisterPage.css';
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAuth } from "../../Context/useAuth";
import { useForm } from "react-hook-form";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import ButtonSpinner from "../ButtonSpinner/ButtonSpinner";

type Props = {};

type RegisterFormsInputs = {
  email: string;
  username: string;
  password: string;
};

const validation = Yup.object().shape({
  email: Yup.string().required("Email is required"),
  username: Yup.string().required("Username is required"),
  password: Yup.string().required("Password is required"),
});

const RegisterPage = (props: Props) => {
  const { registerUser } = useAuth();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<RegisterFormsInputs>({ resolver: yupResolver(validation) });

  const [loading, setLoading] = useState<boolean>(false);

  const handleRegister = async (form: RegisterFormsInputs) => {
    setLoading(true);
    registerUser(form.email, form.username, form.password);
    //TODO remove in production
    await new Promise(resolve => setTimeout(resolve, 500));
    setLoading(false);
  };
  return (
    <section className="register">
        <div className='register-card shadow rounded bg-white col-md-4'>
        <h3>Register</h3>
        <form onSubmit={handleSubmit(handleRegister)}>
            <Form.Group className="mb-3">
                <Form.Label htmlFor="email">Email address</Form.Label>
                <Form.Control id="email" type="email" placeholder="email@example.com" {...register("email")}/>
            </Form.Group>
            {errors.email ? (
                  <p className="text-red">{errors.email.message}</p>
                ) : (
                  ""
                )}
            <Form.Group className="mb-3">
                <Form.Label htmlFor="username">username</Form.Label>
                <Form.Control id='username' type="string" placeholder="MyUsername123" {...register("username")}/>
                {errors.username ? (
                  <p className="text-red">{errors.username.message}</p>
                ) : (
                  ""
                )}
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label htmlFor="password">Password</Form.Label>
                <Form.Control id='password' type="password" placeholder="***********" {...register("password")}/>
                {errors.password ? (
                  <p className="text-red">{errors.password.message}</p>
                ) : (
                  ""
                )}
            </Form.Group>
            <p className="register-link">
              Already a member? <Link to="/login">Login</Link>
            </p>
            <div className="d-grid">
              {loading ? (<ButtonSpinner />) : (
                <Button type="submit" variant="primary">
                    Submit
                </Button>
              )}
            </div>
        </form>
        </div>
    </section>
  );
};

export default RegisterPage;
